import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Inicio from './Components/Pages/Inicio/Inicio';
import Navbar from './Components/Shared/Navbar/Navbar';
import Footer from './Components/Shared/Footer/Footer';
import Planos from './Components/Pages/Planos/Planos';
import NotFound from './Components/Pages/NotFound/NotFound';
import ScrollToTop from './Components/Shared/Functions/ScrollToTop';
import LoginDiscord from './Components/Systems/LoginDiscord';
import RedirectToDiscord from './Components/Systems/RendirectToDiscord/RendirectToDiscord';
import Dashboard from './Components/Pages/Dashboard/Dashboard';
import Login from './Components/Systems/RendirectToDiscord/Login';
import Checkout from './Components/Pages/Planos/Checkout/Checkout';
import Fatura from './Components/Pages/Dashboard/Faturas/Fatura/Fatura';

function LayoutWrapper({ children }) {
  const location = useLocation();
  const hideLayoutOn = ["/dashboard/faturas/"];
  const isHiddenPage = hideLayoutOn.some(path => location.pathname.startsWith(path));

  if (isHiddenPage) {
    return <>{children}</>;
  }

  return (
    <>
      {!isHiddenPage && <Navbar />}
      <div className='appmain'>{children}</div>
      {!isHiddenPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="app">
      <Router>
        <ScrollToTop />
        <LayoutWrapper>
          <Routes>
            <Route exact path="/" element={<Inicio />}></Route>
            <Route exact path="/planos" element={<Planos />} />
            <Route path="/planos/checkout/:id" element={<Checkout />}> </Route>
            <Route path="/logindiscord" element={<LoginDiscord />} />
            <Route path="*" element={<NotFound />}></Route>
            <Route path="/discord" element={<RedirectToDiscord />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/dashboard/*" element={<Dashboard />}></Route>
            <Route path="/dashboard/faturas/:invoiceId" element={<Fatura />}></Route>
          </Routes>
        </LayoutWrapper>
      </Router>
    </div>
  );
}

export default App;
